import { Box, Modal } from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers";
import moment from "moment";
import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
};

const ModalDateRange = ({ open, setOpen, selectedDate, setSelectedDate }) => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          width: isMobileView ? "95%" : "50%",
          maxHeight: "85vh",
          padding: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
        className="text-left hide-scrollbar"
      >
        <div className="py-1 px-2 lg:px-4 lg:py-4 border-b border-gray-200 shrink-0">
          <div className="flex justify-between items-center">
            <h1 className="text-lg lg:text-xl text-slate-500 flex items-center gap-1 lg:gap-2 font-medium">
              Pilih
              <span className="text-slate-700">Periode</span>
            </h1>
            <IoClose
              className="hover:text-red-700 cursor-pointer w-5 md:w-6 h-full hover:bg-gray-100 rounded-md transition-transform duration-300 ease-in-out hover:rotate-90"
              onClick={handleClose}
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-2 lg:p-4">
          <div className="flex flex-col gap-2 mb-4">
            <div className="py-2 px-4 bg-gray-100 rounded-full border text-md border-gray-200">
              <p className={`text-center ${isMobileView ? "text-sm" : ""}`}>
                {selectedDate[0] === ""
                  ? "Tanggal belum dipilih"
                  : moment(selectedDate[0]).format("DD MMM YYYY")}{" "}
                {selectedDate[1] !== "" && (
                  <>
                    <span className="mx-2">s/d</span>
                    {moment(selectedDate[1]).format("DD MMM YYYY")}
                  </>
                )}
              </p>
            </div>
          </div>

          <div
            className={`${
              isMobileView
                ? "flex flex-col gap-4 mb-2"
                : "flex gap-2 mb-2 items-start"
            }`}
          >
            <div className={`${isMobileView ? "w-full" : "flex-1"}`}>
              <p
                className={`text-center font-medium text-md mb-1 ${
                  isMobileView ? "text-sm" : ""
                }`}
              >
                Tanggal Mulai
              </p>
              <div className="bg-indigo-50 rounded-lg">
                <DateCalendar
                  value={
                    selectedDate[0] === "" ? null : moment(selectedDate[0])
                  }
                  onChange={(e) =>
                    setSelectedDate([
                      e ? moment(e).format("YYYY-MM-DD") : "",
                      selectedDate[1],
                    ])
                  }
                  sx={{
                    width: "100%",
                    fontFamily: '"Montserrat", sans-serif',

                    "& *": {
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiDateCalendar-root": {
                      width: "100%",
                      height: isMobileView ? 280 : 300,
                    },

                    "& .MuiPickersCalendarHeader-root": {
                      paddingLeft: isMobileView ? 1 : 2,
                      paddingRight: isMobileView ? 1 : 2,
                    },

                    "& .MuiPickersCalendarHeader-label": {
                      fontSize: isMobileView ? "0.875rem" : "1rem",
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiDayCalendar-weekDayLabel": {
                      fontSize: isMobileView ? "0.75rem" : "0.875rem",
                      width: isMobileView ? 36 : 32,
                      height: isMobileView ? 36 : 32,
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiPickersDay-root": {
                      fontSize: isMobileView ? "0.75rem" : "0.875rem",
                      width: isMobileView ? 36 : 32,
                      height: isMobileView ? 36 : 32,
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiPickersArrowSwitcher-button": {
                      padding: isMobileView ? 0.5 : 1,
                    },
                  }}
                />
              </div>
            </div>

            <div className={`${isMobileView ? "w-full" : "flex-1"}`}>
              <p
                className={`text-center font-medium text-md mb-1 ${
                  isMobileView ? "text-sm" : ""
                }`}
              >
                Tanggal Selesai
              </p>
              <div className="bg-indigo-50 rounded-lg">
                <DateCalendar
                  value={
                    selectedDate[1] === "" ? null : moment(selectedDate[1])
                  }
                  onChange={(e) =>
                    setSelectedDate([
                      selectedDate[0],
                      e ? moment(e).format("YYYY-MM-DD") : "",
                    ])
                  }
                  sx={{
                    width: "100%",
                    fontFamily: '"Montserrat", sans-serif',

                    "& *": {
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiDateCalendar-root": {
                      width: "100%",
                      height: isMobileView ? 280 : 300,
                    },

                    "& .MuiPickersCalendarHeader-root": {
                      paddingLeft: isMobileView ? 1 : 2,
                      paddingRight: isMobileView ? 1 : 2,
                    },

                    "& .MuiPickersCalendarHeader-label": {
                      fontSize: isMobileView ? "0.875rem" : "1rem",
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiDayCalendar-weekDayLabel": {
                      fontSize: isMobileView ? "0.75rem" : "0.875rem",
                      width: isMobileView ? 36 : 32,
                      height: isMobileView ? 36 : 32,
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiPickersDay-root": {
                      fontSize: isMobileView ? "0.75rem" : "0.875rem",
                      width: isMobileView ? 36 : 32,
                      height: isMobileView ? 36 : 32,
                      fontFamily: '"Montserrat", sans-serif',
                    },

                    "& .MuiPickersArrowSwitcher-button": {
                      padding: isMobileView ? 0.5 : 1,
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="p-2 lg:p-4 border-t border-gray-200 shrink-0">
          <div className="w-full flex items-center justify-end gap-1 lg:gap-2">
            <button
              className="w-full lg:w-fit h-6 lg:h-10 text-slate-700 text-sm lg:text-md bg-slate-100 border lg:border border-slate-700 rounded-lg lg:font-medium hover:bg-slate-200 cursor-pointer px-4 transition-all duration-200 disabled:bg-gray-300 disabled:cursor-default disabled:border-gray-300 disabled:text-white"
              onClick={() => {
                setSelectedDate(["", ""]);
                setOpen(false);
              }}
              type="button"
            >
              Semua Tanggal
            </button>
            <button
              disabled={selectedDate.includes("")}
              className="w-full lg:w-fit h-6 lg:h-10 text-white text-sm lg:text-md bg-secondary border lg:border-2 border-secondary rounded-lg lg:font-medium hover:bg-secondaryHover cursor-pointer px-6 transition-all duration-200 disabled:bg-gray-300 disabled:cursor-default disabled:border-gray-300 disabled:text-white"
              onClick={handleClose}
              type="button"
            >
              Pilih Tanggal
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalDateRange;
